import { Component } from '@angular/core';
import { AppComponent } from '../app.component';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss'],
  imports: [
    MatIconModule,
    MatIconButton,
    FlexLayoutModule,
  ],
})
export class MenuButtonComponent {
  constructor(private appComp: AppComponent) { }

  toggle(): void {
    this.appComp.drawerToggle();
  }
}
